export const fmtNum = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "0";
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return (n / 1_000_000).toFixed(2) + "M";
  if (abs >= 1_000) return (n / 1_000).toFixed(1) + "K";
  return new Intl.NumberFormat("en-US").format(Math.round(n));
};

export const fmtMoney = (n, cur = "USD") => {
  if (n === null || n === undefined || isNaN(n)) n = 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: cur,
    maximumFractionDigits: 2,
  }).format(n);
};

export const fmtPct = (n) => `${(n || 0).toFixed(2)}%`;

export const isoDaysAgo = (days) => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().slice(0, 10);
};

export const today = () => new Date().toISOString().slice(0, 10);

export const deltaColor = (v, invert = false) => {
  if (!v) return "text-zinc-500";
  const good = invert ? v < 0 : v > 0;
  return good ? "text-lime-400" : "text-rose-400";
};
